import { UNIFIED_ROUTE_FAQ } from '~/constants/routes/unified';
import { RETIRED_FAQ_SECTION_SEGMENT } from '~/utils/faq/faqSectionLabelKeys';

const LEARNING_ASSETS_PATH = '/content/learning-assets';

const RETIRED_TOPICS_PREFIX = '/content/topics';
const RETIRED_STORY_ASSETS_INDEX = '/content/story-assets';

const RETIRED_FAQ_PATHS = ['/faq', `/faq/${RETIRED_FAQ_SECTION_SEGMENT}`];

const retiredPathTarget = (path: string): string | undefined => {
  const trimmed = path.replace(/\/+$/, '');
  if (RETIRED_FAQ_PATHS.includes(trimmed)) {
    return UNIFIED_ROUTE_FAQ;
  }
  if (trimmed === RETIRED_STORY_ASSETS_INDEX
    || trimmed === RETIRED_TOPICS_PREFIX
    || trimmed.startsWith(`${RETIRED_TOPICS_PREFIX}/`)) {
    return LEARNING_ASSETS_PATH;
  }
  return undefined;
};

/**
 * Retired paths canonicalise to their replacement so old bookmarks keep working:
 * the content-admin topic and story-asset lists go to the learning assets list,
 * and the bare public FAQ path and the old `/faq/default` go to the general FAQ section. Done here rather
 * than via `routeRules`: a nitro redirect sets the Location header verbatim, and
 * Caddy strips the cluster prefix before Nuxt, so `/au/content/topics` would land
 * on the root cluster.
 */
export default defineNuxtRouteMiddleware((to) => {
  const target = retiredPathTarget(to.path);
  if (!target) {
    return;
  }

  return navigateTo({ path: clusterRedirectPath(target), query: to.query }, { replace: true, redirectCode: 301 });
});
